import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// Images
import { useI18next, Trans } from "gatsby-plugin-react-i18next";
import { StaticImage } from "gatsby-plugin-image";

const SingleImage = () => {
  const { t } = useI18next();
  return (
    <section id="home" className="banner image-bg">
      <div className="background-image">
        <StaticImage src="../../images/banner/bg.jpg" alt="bg" />
      </div>

      {/* <!-- Container --> */}
      <Container>
        <Row className="align-items-center">
          {/* <!-- Content --> */}
          <Col className="col-12 col-lg-5 res-margin">
            {/* <!-- Banner text --> */}
            <div className="banner-text">
              <h1 className="wow fadeInUp" data-wow-offset="10" data-wow-duration="1s" data-wow-delay="0s">
              {t("smartDeskSharingSoftware")}
              </h1>
              <br/>

              <p className="wow fadeInUp" data-wow-offset="10" data-wow-duration="1s" data-wow-delay="0.3s">
                <b>smartbooking365</b>
                <br />
                <Trans i18nKey="dieLoesung">
                  this is just  <strong>a</strong> template.
                </Trans>
                <br />
                <br />
                {t("modernWorkplaces")}
              </p>
            </div>
          </Col>

          {/* <!-- Image --> */}
          <Col className="col-12 col-lg-7">
            <div className="banner-image wow fadeInUp" data-wow-offset="10" data-wow-duration="1s" data-wow-delay="0.3s">
              <StaticImage src="../../images/desk-booking-tablet-phone.png" alt="Desk Booking Tablet Phone" className="bounce-effect" />
            </div>
          </Col>
        </Row>
      </Container>

      {/* <!-- Wave effect --> */}
      <div className="wave-effect wave-anim">
        <div className="waves-shape shape-one">
          <div className="wave wave-one"></div>
        </div>

        <div className="waves-shape shape-two">
          <div className="wave wave-two"></div>
        </div>

        <div className="waves-shape shape-three">
          <div className="wave wave-three"></div>
        </div>
      </div>
    </section>
  );
};

export default SingleImage;
